import { Helmet } from 'react-helmet';
import Cursor from '@/components/common/cusor';
import Error from '@/components/error404/Error';
export default function LPageError() {
  return (
    <>
      <Helmet>
        <title>GCAD</title>
        <link rel="icon" href="/light/assets/imgs/fox.png" />
        <link rel="shortcut icon" href="/light/assets/imgs/fox.png" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
      </Helmet>


      <div>
        <Cursor />
        <div id="smooth-wrapper">
          <Error/>
        </div>
      </div>
    </>
  );
}
